import { useMemo } from "react";
import { Entity } from "@common/types/entity";
import {
    useEntitiesContexts,
    UseEntitiesContextsOptions,
} from "./useEntitiesContexts";

export function useEntities(options: UseEntitiesContextsOptions = {}) {
    const ec = useEntitiesContexts(options);
    return useMemo(() => ec?.map((e) => e.entity) ?? [], [ec]);
}

export function useEntitiesById(
    options: UseEntitiesContextsOptions = {},
): Map<number, Entity> {
    const entities = useEntities(options);
    return useMemo(() => new Map(entities.map((e) => [e.id, e])), [entities]);
}

export function useEntitiesByUuid(
    options: UseEntitiesContextsOptions = {},
): Map<string, Entity> {
    const entities = useEntities(options);
    return useMemo(() => new Map(entities.map((e) => [e.uuid, e])), [entities]);
}
